import React from 'react';

export function Loader ({ref}) {
  return (
    <div ref={ref} className="Loader position-fixed d-flex align-items-center justify-content-center">
      STUDIO MOONO
    </div>
  );
}

export function Crash ({ref}) {
  return (
    <div ref={ref} className="Crash position-fixed d-flex align-items-center justify-content-center">
      Something went wrong. Please try to refresh this webpage.
    </div>
  );
}